import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';
import { VayuBlocksCssJustify } from '@vayu-blocks/global';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';

export default function AdvanceSettings({ children, attributes }) {
    const view = VayuBlocksDevice();

    const justifyStyle={
        display:'flex',
        alignItems:'center',
        ...VayuBlocksCssJustify(attributes.alignment, view),
    }

    const { mergedStyles, handleMouseEnter, handleMouseLeave ,responsiveClasses, hoverAnimationClass} = VayuBlockAdvanceStyle(attributes);

    const hoverboxShadow = attributes.iconboxShadowHvr
    ? `${attributes.iconboxShadowHorizontalHvr}px ${attributes.iconboxShadowVerticalHvr}px ${attributes.iconboxShadowBlurHvr}px ${attributes.iconboxShadowSpreadHvr}px rgba(${
        parseInt(attributes.iconboxShadowColorHvr.slice(1, 3), 16)}, 
        ${parseInt(attributes.iconboxShadowColorHvr.slice(3, 5), 16)}, 
        ${parseInt(attributes.iconboxShadowColorHvr.slice(5, 7), 16)}, 
        ${attributes.iconboxShadowColorOpacityHvr / 100})`
    : 'none';

    const advanceStyle = {
        ...(attributes.animationData && { '--icon-box-shadow-glow-half': `0 0 15px 15px ${attributes.animationData?.background?.bg}` }),
        ...(attributes.animationData && { '--animation-box-icon': attributes.animationData?.background?.bg }),
        ...(attributes.iconSize.Desktop && { '--icon-size-font': attributes.iconSize.Desktop}),
        ...(attributes.iconSize.Tablet && { '--icon-size-font-tablet': attributes.iconSize.Tablet }),
        ...(attributes.iconSize.Mobile && { '--icon-size-font-mobile': attributes.iconSize.Mobile }),
        ...(attributes.rotate && { '--icon-rotate-degree': `${attributes.rotate}deg` }),
        ...(attributes.color && { '--icon-color-svg': attributes.color }),
        '--icon-hover-color-svg': attributes.hoverColor || attributes.color,
        ...(attributes.backgroundcolor && { '--backgorund-box-icon': attributes.backgroundcolor }),
        '--backgorund-hover-box-icon': attributes.backgroundhoverColor || attributes.backgroundcolor,
        ...(attributes.hoverColor && { '--color-hover-box-icon': attributes.hoverColor }),
        ...(hoverboxShadow && { '--icon-box-icon-hover-boxShadow': hoverboxShadow }),
        ...(attributes.textbackground && { '--text-icon-settings-textbackground': attributes.textbackground }),
        ...(attributes.textcolor && { '--text-icon-settings-textcolor': attributes.textcolor }),
        ...(attributes.textx && { '--text-icon-settings-textx': attributes.textx }),
        ...(attributes.texty && { '--text-icon-settings-texty': attributes.texty }),

            '--text-hover-color': attributes.textcolorhover || attributes.textcolor,
        ...(attributes.strokeWidthtext && attributes.stroketext && { '--stroke-text-settings': `${attributes.strokeWidthtext}px ${attributes.stroketext}` }),
    };
   
    const style = { ...mergedStyles, ...advanceStyle , ...justifyStyle};

    const blockProps = useBlockProps({
        className: `${responsiveClasses}`,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        style: {...style}
    });

    return (
        <div {...blockProps}>
            {children}
        </div>
    );
}